module.exports = __webpack_public_path__ + "img/aboutUs_pic2.3e595950.png";